import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hydrao-register-confirmation',
  templateUrl: './register-confirmation.component.html',
  styleUrls: ['./register-confirmation.component.scss']
})
export class RegisterConfirmationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
